module.exports = __webpack_public_path__ + "835332481f169fda5d702c39cdf816ee.png";